import React, { useState, useRef, useEffect, useMemo } from "react";
import { addData, deleteData, editData, getData } from "../../controllers/careerGuidanceInternships.controller";
import moment from "moment";
import DatePicker from "react-datepicker";

import toast from 'react-hot-toast';
import {
    IconPlus,
} from "@tabler/icons-react";
import { RiListRadio, RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import Button from "../../Components/Button";
import Page from "../../Components/Page";
const CareerGuidanceInternships = () => {

    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);

    const [formData, setFormData] = useState({     
        title: "",
        url: "",
      
    });

   
    const [toggles, setToggles] = useState([
        { label: 'Add New', icon: <IconPlus />, isToggled: false },
        { label: 'List', icon: <RiListRadio />, isToggled: true },
    ]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, file: e.target.files[0] });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted: ", formData);
        // Add form submission logic here
    };




    // get
    const fetchTableData = async () => {
        const res = await getData({})
        console.log('res => ', res)

        if (res.status === 200) {
            const apiData = res?.data?.data;
            const tableData = apiData?.map((d) => ({
                id: d.id,
                title: d.title,
               // url: d.url
              url: d.url || "",
            }))
            setData(tableData)           
        }
    }

    useEffect(() => {
        fetchTableData()
      
    }, [])




// add
    const addBtn = async () => {
        try {
            const { title, url } = formData;

            if (!title || !url )
                
                {
                toast.error("Please fill in all the required fields and upload a document.");
                return;
            }

            toast.loading("Submitting your data...");


            const res = await addData({
                title,
                url,
               
            });

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({

                    title: "",
                    url: "",
                    

                });
              
                fetchTableData()
            } else {
                toast.error(message || "Failed to add research data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);


            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };



// edit
    const editBtn = async () => {
        try {
            const {  title, url } = formData;

            if (!title || !url ) {
                toast.error("Please fill in all the required fields and upload a document.");
                return;
            }

            toast.loading("Submitting your data...");


            const res = await editData({
                id: selectedRowId,
                title,
                 url
               

            });

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({

                    event_name: "",
                    date: "",
                    location: "",
                    description: "",
                    file: null,

                });

                document.getElementById("modal-edit").close()
                fetchTableData()
            } else {
                toast.error(message || "Failed to add Career Guidance and Internship data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);


            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };


// delete
    const deleteBtn = async (index) => {
        try {
            const rowToDelete = data[index];
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deleteData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    setData((prevData) => prevData.filter((_, i) => i !== index));
                    toast.success(message);
                    fetchTableData()
                    setSelectedRowId(null)
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }
    // const deleteBtn = async (index) => {
    //     try {
    //         const rowToDelete = data[index];
    //         if (!window.confirm(`Are you sure you want to delete: "`)) return;

    //         toast.loading("Deleting record...");
           
    //         toast.dismiss();

    //         const res = await deleteData({ id: selectedRowId})
    //         console.log("deleted data", res)
    //         const message = res.data.message;
    //         toast.dismiss();

    //         if (res.status === 200) {
    //             toast.success(res.data.message || "Record deleted successfully.");
    //             setData((prevData) => prevData.filter((_, i) => i !== index)); // Update state by removing the deleted row
    //         } else {
    //             toast.error(res.data.message || "Failed to delete the record.");
    //         }
    //     } catch (error) {
    //         console.error("Error deleting data:", error);
    //         toast.dismiss();
    //         toast.error("Failed to delete the record.");
    //     }
    // };
   
    
    const handleToggle = (index) => {
        setToggles((prevToggles) =>
            prevToggles.map((toggle, i) => ({ ...toggle, isToggled: i === index }))
        );
    };

    const toggeledIndex = useMemo(() => {
        return toggles.findIndex((d) => d.isToggled)
    }, [toggles])

    return (
        <Page className="px-8 py-6">
            <div className='flex text-xl gap-10 items-center'>
                <div className="text-[#100f13]">
                    Research & Student Life / Student Life /  <span className="text-[black] bg-white mt-6"> Career Guidance & Internships</span>
                </div>
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
                {toggles.map((toggle, index) => (
                    <div key={toggle.id} className="flex flex-col items-center">

                        <Button styles={'h-100'} outlined={!toggle.isToggled} onClick={() => handleToggle(index)}>
                            <span className="flex flex-row items-center justify-center w-[150px]">{toggle.icon} {toggle.label}</span>
                        </Button>

                    </div>

                ))}
            </div>

            <div className="w-full mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg">
                {toggeledIndex === 1 ? (
                   <div>
                   <h1 className="text-xl font-bold mb-2 text-[#4B465C] mt-6"> Resource List</h1>

                   <table className="w-full border-collapse bg-white rounded-lg shadow-md">
                       <thead>
                           <tr className="bg-gray-100 text-[#4B465C]">
                               <th className="py-2 px-4 w-1/4 text-center">Title</th>
                               <th className="py-2 px-4 w-1/4 text-center">File Link </th>

                               <th className="py-2 px-4 w-1/4 text-center">Actions</th>
                           </tr>
                       </thead>
                       <tbody>
                           {data.map((item, index) => (
                               <tr key={item.id} className="border-b hover:bg-gray-50">
                                   <td className="py-2 px-4 text-center">{item.title}</td>
                                   {/* <td className="py-2 px-4 text-center text-[#00A3FF] ">{item.url}</td> */}
                                   <td  className="py-2 px-4 text-center text-[#00A3FF] truncate"
    style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
    title={item.url}>{item.url}</td>

                                   <td className="py-2 px-4 text-center">
                                       <div className="flex justify-center gap-4">
                                           <button
                                               onClick={() => {
                                                   setSelectedRowId(item.id)
                                                   document.getElementById("modal-delete").showModal();
                                               }}
                                               className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                           >
                                               Delete
                                               <RiDeleteBin2Line className="ml-2" />
                                           </button>

                                           <button onClick={() => {
                                               console.log('item data => ', item)
                                               setSelectedRowId(item.id)
                                               setFormData((prevState) => ({
                                                   ...prevState,                                                        
                                                   title: item.title,
                                                   url: item.url,
                                                  

                                               }))
                                               document.getElementById("modal-edit").showModal();
                                           }} className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1">
                                               Edit
                                               <FiEdit />
                                           </button>
                                       </div>
                                   </td>
                               </tr>
                           ))}
                       </tbody>
                   </table>
               </div>

                ) : (
                    <div>
                        <h1 className="text-2xl font-bold mb-6">Add Link</h1>
                        <form onSubmit={(e) => e.preventDefault()}>
                       

                                <div className="mb-4">
                                    <label htmlFor="title" className="block text-sm font-medium text-gray-700">
                                        Title
                                    </label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                                    />
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="url" className="block text-sm font-medium text-gray-700">
                                        Url
                                    </label>
                                    <input
                                        type="text"
                                        id="url"
                                        name="url"
                                        value={formData.url}
                                        onChange={handleChange}
                                        className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                                    />
                                </div>
                           

                            <div className="flex justify-end space-x-4">
                                    <button
                                        type="button"
                                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md"
                                        onClick={() => {
                                      
                                         
                                        }}
                                    >
                                        Cancel
                                    </button>

                                <button
                                    type="button"
                                 onClick={addBtn}
                                    className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                )
                }
            </div>
            <dialog
    id="modal-edit"
    className="modal modal-bottom xl:modal-middle inset-0 z-50 rounded-lg w-[600px]"
>
    <div className="p-6">
        <h1 className="text-2xl font-bold mb-6">Edit Link </h1>
        <form onSubmit={(e) => e.preventDefault()}>
           

            

            <div className="mb-4">
                <label htmlFor="title" className="block text-sm font-medium text-gray-700">
                Title
                </label>
                <input
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                />
            </div>

            <div className="mb-4">
                <label htmlFor="url" className="block text-sm font-medium text-gray-700">
                    Url
                </label>
                <textarea
                    id="url"
                    name="url"
                    value={formData.url}
                    onChange={handleChange}
                    rows="4"
                    className="block w-full border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
                />
            </div>

            <div className="flex justify-end space-x-4">
                <button
                    type="button"
                    className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md"
                    onClick={() => {
                        document.getElementById("modal-edit").close()}}
                >
                    Cancel
                </button>
                <button
                    type="button"
                   onClick={editBtn}
                    className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                >
                    Save
                </button>
            </div>
        </form>
    </div>
</dialog>



            <dialog
                id="modal-delete"
                className="modal modal-bottom sm:modal-middle inset-0 z-50 rounded-lg"
            >

                <div className="relative bg-white rounded-lg shadow-lg p-6 max-w-lg w-full mx-auto z-10">
                    <div className="text-center">
                        <h2 className="text-xl font-bold text-gray-900">
                            Delete
                        </h2>
                        <p className="text-gray-500 font-bold">
                            Are you sure?
                        </p>
                    </div>


                    <div className="mt-4 flex justify-center space-x-4">
                        <button
                            onClick={() => {
                                setSelectedRowId(null)
                                document.getElementById("modal-delete").close()
                            }}
                            className="rounded-lg hover:bg-gray-200 transition active:scale-95 hover:shadow-lg px-6 py-3 bg-gray-200 text-gray-600"
                        >
                            No
                        </button>
                        <button
                           onClick={async () => { deleteBtn(); }}
                            className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                        >
                            Yes
                        </button>
                    </div>
                </div>
            </dialog>

        </Page>

    );
};

export default CareerGuidanceInternships;




